<div class="mb-5" *ngIf="totalRows > 0">
    <b>{{pageStatus}}</b> of {{totalRows}}
</div>

<div #droprDown class="drop-down-wrapper mb-5" *ngIf="totalRows > 0 && showPageSizeChangeController != 'disable'">
    <lib-select [placeholder]="pageSize.toString()" (change)="selectChangeHandler($event)"
        contentClass="no-border pagesize-controller" [label]="'Show'" [defaultHighlightFirst]=false>
        <lib-option *ngFor="let option of options" [label]="option.toString()" [value]="option.toString()" class="grayOption"
            [ngClass]="{ selected: option === pageSize }"></lib-option>
    </lib-select>
</div>